const ChatSources = {
    SENT: 'sent',
    RECEIVED: 'received',
};

export { ChatSources };
